import React from 'react'
import './footer.css'
export const Footer = () => {
  return (
    <footer className='footer'>
        <div> By Ashenafi and Alina</div>
       <div>
       <a href='https://github.com/ashenafykebede/timer-app' target='_blank'>GitHub Repo Here</a>
       </div>
    </footer>
  )
}

export default Footer